import React from 'react';

import {
  InformationMessageRequestDtoUserProfileListEnum,
  InformationMessageViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { Select } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { useApi } from 'hooks/ApiStoreContext';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { InformationMessageFormValues } from 'types/InformationMessage/InformationMessage';
import { CSSUtils } from 'utils/CSSUtils';
import { infoMessageProfileMapping } from 'utils/enumData';

import {
  generateRequestDtoFromFormData,
  validateInformationMessageRequest,
} from '../utils';

function SelectProfile({
  values,
}: FieldProps<InformationMessageFormValues>): React.ReactElement {
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  const controller = useApi().AdminFonctionnelControllerApi;
  const key: keyof InformationMessageFormValues = 'profiles';

  // list of options of select

  const informationMessageProfilesSansJustice: InformationMessageRequestDtoUserProfileListEnum[] =
    [
      InformationMessageRequestDtoUserProfileListEnum.AUTORITE_FOURRIERE,
      InformationMessageRequestDtoUserProfileListEnum.FORCE_DE_L_ORDRE,
      InformationMessageRequestDtoUserProfileListEnum.GARDIEN_FOURRIERE,
      InformationMessageRequestDtoUserProfileListEnum.BORD_DE_ROUTE,
    ];

  const selectEnums = JUSTICE_ACTIVE_BOOL
    ? Object.values(InformationMessageRequestDtoUserProfileListEnum)
    : informationMessageProfilesSansJustice;

  const selectItems = selectEnums
    .map(profile => ({
      value: profile,
      displayValue: infoMessageProfileMapping[profile],
    }))
    .sort((a, b) => (a.displayValue || '').localeCompare(b.displayValue));

  return (
    <Select
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Utilisateurs concernés',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value:
                  | InformationMessageRequestDtoUserProfileListEnum[]
                  | undefined,
              ): Promise<void> => {
                const requestObject = generateRequestDtoFromFormData({
                  ...values,
                  profiles: value || undefined,
                });

                return await validateInformationMessageRequest(
                  controller,
                  requestObject,
                  InformationMessageViolationDtoFormFieldEnum.PROFILES,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.LlargeWrapperCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      optionProps={selectItems}
      selectProps={{
        placeholder: FormPlaceholders.Select,
        mode: 'multiple',
      }}
    />
  );
}

export default SelectProfile;
